import * as React from 'react';

import { trackIsSoldFurnishedLabelShow, trackShowRosreestrCheckedLabel } from './tracking';
import { LabelsList } from '../../../components/LabelsList';
import { useOfferContext } from '../../../context';
import { isCommercial } from '../../../utils/computedProps/commercial/isCommercial';
import { getIsDailyRent } from '../../../utils/computedProps/price/rent/getIsDailyRent';
import { CommercialLabelsContainer } from '../commercial/CommercialLabelsContainer';

export function LabelsListContainer() {
  const { labels, jsonQuery, offer, position, isRosreestrCheckedLabelAvailable, isSoldFurnishedLabelAvailable } =
    useOfferContext();
  const isHotel = offer?.dailyrent?.hotelData?.isHotel;
  const isDailyRent = getIsDailyRent(offer.category);
  const commercial = isCommercial(offer);

  const labelsToShow = [...labels];

  const onShow = React.useCallback(() => {
    if (isRosreestrCheckedLabelAvailable) {
      trackShowRosreestrCheckedLabel(jsonQuery, { offerId: offer.id, position });
    }

    if (isSoldFurnishedLabelAvailable) {
      trackIsSoldFurnishedLabelShow(jsonQuery, { offerId: offer.id, position });
    }
  }, [isRosreestrCheckedLabelAvailable, isSoldFurnishedLabelAvailable, jsonQuery, offer.id, position]);

  if (isHotel || offer.isBookedFromDeveloper) {
    return null;
  }

  if (commercial) {
    return <CommercialLabelsContainer />;
  }

  if (!labelsToShow.length) {
    return null;
  }

  return <LabelsList labels={labelsToShow} onShow={onShow} isDailyRent={isDailyRent} />;
}
